module.exports = __webpack_public_path__ + "static/media/ios-pie.07587ea2.svg";